import useSlingApi from '@sdk/api/useSlingApi';
import { useMutation } from '@tanstack/react-query';
import useToast from '@sdk/common/toast/useToast';
import gettext from '@sdk/lang/gettext';

import { useShiftTaskMappers } from './useShiftTaskMappers';
import { useShiftTaskInstancesQueryCache } from './useShiftTasksInstancesQueryCache';

export function useCompleteShiftTask() {
  const { shiftTasks } = useSlingApi();
  const { showSuccessToast } = useToast();
  const { mapTaskInstanceAPIToUI } = useShiftTaskMappers();
  const { updateShiftTaskInstance } = useShiftTaskInstancesQueryCache();

  const mutation = useMutation({
    mutationFn: async (id: ID) => {
      const result = await shiftTasks.completeTask(id);
      return mapTaskInstanceAPIToUI(result.data);
    },
    onSuccess: (payload) => {
      updateShiftTaskInstance(payload);
      showSuccessToast(gettext('Task successfully completed.'));
    },
  });

  return mutation;
}
